import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
// import { Link } from "react-router";
import Intro from "./Retire/Intro";
import RIGEquation from "./Retire/RIGEquation";
import Solution from "./Retire/Solution";
import Accumulation from "./Retire/accumulation";

class Retire extends Component {
  components = [Intro, RIGEquation, Solution];
  components2 = [Intro, Accumulation, RIGEquation, Solution];
  state = {
    id: 0,
    step: 0,
    steps: [
      {
        title: "Intro",
        full_title: "Retirement Planning"
      },
      {
        title: "Decumulation",
        full_title: "Retirement Income Gap"
      },
      {
        title: "Solution",
        full_title: "Retirement Solution"
      }
    ],
    steps2: [
      {
        title: "Intro",
        full_title: "Retirement Planning"
      },
      {
        title: "Accumulation",
        full_title: "Retirement Income Gap"
      },
      {
        title: "Decumulation",
        full_title: "Retirement Income Gap"
      },
      {
        title: "Solution",
        full_title: "Retirement Solution"
      }
    ]
  };

  componentDidMount() {
    this.setState({ id: this.props.params.id });
  }
  componentWillMount() {
    this.props.setPath(["Retirement"]);
  }

  //setting step to zero if clicked on navigation
  componentWillReceiveProps(newProps) {
    if (this.state.step !== 0 && newProps.activeStep !== null) {
      this.setState({
        step: newProps.activeStep
      });
    }
  }
  nextStepCallBack = nextStep => {
    let { step } = this.state;
    if (nextStep) {
      this.setState({ step: ++step });
    }
  };
  setStep(step) {
    this.setState({ step });
  }

  // nav to next step
  nav = () => {
    let { step, steps, steps2 } = this.state;
    let { selectedPlan } = this.props;
    if (selectedPlan === "accumulation") {
      if (steps2.length > +step + 1) {
        this.setState({ step: ++step });
      }
    } else {
      if (steps.length > +step + 1) {
        this.setState({ step: ++step });
      }
    }
  };

  render() {
    const { step, steps, steps2 } = this.state;

    // const selected_steps =
    //   this.props.selectedPlan === "accumulation" ? steps2 : steps;

    // const CurrentStep = (() => portfolioActive ? this.components_lite[step] : this.components[step])()

    const CurrentStep = (() =>
      this.props.selectedPlan === "accumulation"
        ? this.components2[step]
        : this.components[step])();

    return (
      <div className="page-content">
        <div className="head-section">
          <h1 className="text-uppercase">
            {this.props.heading}
            <sup>
              <small>
                {" "}
                <b>BETA</b>{" "}
              </small>
            </sup>
          </h1>

          <ul className="steps">
            {this.props.selectedPlan === "accumulation" ? (
              <Fragment>
                {steps2.map((v, i) => (
                  <li className={step === i ? "active" : null} key={i}>
                    <a
                      data-toggle="tab"
                      className="steps__step"
                      onClick={() => this.setStep(i)}
                    >
                      <span className="steps__step-number">
                        <span>{i + 1}</span>
                      </span>
                      <span className="steps__step-desc">
                        {steps2[i].title}
                      </span>
                    </a>
                  </li>
                ))}
              </Fragment>
            ) : (
              <Fragment>
                {steps.map((v, i) => (
                  <li className={step === i ? "active" : null} key={i}>
                    <a
                      data-toggle="tab"
                      className="steps__step"
                      onClick={() => this.setStep(i)}
                    >
                      <span className="steps__step-number">
                        <span>{i + 1}</span>
                      </span>
                      <span className="steps__step-desc">{steps[i].title}</span>
                    </a>
                  </li>
                ))}
              </Fragment>
            )}
          </ul>
        </div>
        {/* added current step1 for nav to accumulation to decumulation */}
        <CurrentStep
          nextStepCallBack={this.nextStepCallBack}
          navToNextPage={this.nav}
        />
      </div>
    );
  }
}

export default connect(
  ({
    layout: { activeStep },
    retirement: {
      rig: {
        intro: { heading, selectedPlan }
      }
    }
  }) => ({ heading, selectedPlan, activeStep }),
  null
)(Retire);



// WEBPACK FOOTER //
// ./src/components/pages/Retire.jsx